import $ from "jquery";

import {paymentOnSubmitTrack} from "./paymentSubmitCommon";
import {inputHasError, validateCVV, validateDisabledButton} from "./validation";

let cardInput;
let cardExpiryDate;
let cvvInput;
let paymentSubmit;
let paymentDetails;
// let membershipCheckbox;
// let termsCheckbox;
let alreadySubmitted;
let paymentForm;
let paymentSwitchers;
let cardFields;
let bankFields;

// let cardValue = "";
let cvvValue = "";

let inputsToCheck = [];
let cardRequiredInputs = [];
let bankRequiredInputs = [];
let outsideRequiredInputs = [];

const onChangeCVV = (event) => {
  const value = event.target.value;
  if (!validateCVV(value)) {
    event.preventDefault();
    event.target.value = cvvValue;
    return false
  }
  cvvValue = value;
}

const onChangeCard = (event) => {
  const value = event.target.value;
  if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') {
    return;
  }
  event.target.value = value.replace(/\W/gi, '').replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim();
}

function onChangeExpiry(event) {
  const currentValue = event.target.value;
  let inputValue = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters

  if (inputValue.length > 2 || (inputValue.length === 2 && (currentValue.length === 3) && currentValue[2] === "/")) {
    // Insert a slash after the second digit if it's not already there
    inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2);
  }

  // Update the input value
  event.target.value = inputValue;
}

const onInputFocus = (event) => {
  if (!event.target.classList.contains("ui-input--touched")) {
    event.target.classList.add("ui-input--touched")
  }
  if (!event.target.classList.contains("ui-input--focused")) {
    event.target.classList.add("ui-input--focused")
  }
}

export const onChangeInput = (event, isBlur = false) => {
  const hasError = inputHasError(event.target, true);

  let neededInputs = inputsToCheck;

  if (neededInputs
    .filter(input => input && (input.name !== event.target.name))
    .every(input => input.value)) {
    if (hasError && event.target.classList.contains("ui-input--focused")) {
      event.target.classList.remove("ui-input--error");
    }
    validateDisabledButton(paymentSubmit, neededInputs);
  }
  hasError
    ? event.target.classList.add("ui-input--error")
    : event.target.classList.remove("ui-input--error");
  if (event.target.value && !event.target.classList.contains("ui-input--has-value")) {
    event.target.classList.add("ui-input--has-value")
  } else if (!event.target.value && event.target.classList.contains("ui-input--has-value")) {
    event.target.classList.remove("ui-input--has-value")
  }
  if (isBlur) {
    event.target.classList.remove("ui-input--focused");
  }
}

const onBlurInput = (event) => {
  onChangeInput(event, true);
}

const onPaymentSubmit = (event) => {
  inputsToCheck.forEach(input => {
    if (!input) {
      return
    }
    onBlurInput({target: input})
  });
  const buttonDisabled = validateDisabledButton(paymentSubmit, inputsToCheck);
  if (buttonDisabled || alreadySubmitted) {
    paymentSubmit.disabled = true;
    event.preventDefault();
    if (paymentDetails) {
      $("html, body").animate({scrollTop: paymentDetails.offsetTop + 150}, 500)
    }
    return false
  }
  alreadySubmitted = true;
  paymentOnSubmitTrack(event);
}

function updatePaymentUI(event) {
  const hasSwitchers = paymentSwitchers && paymentSwitchers.length > 0;

  // If no switchers exist, assume bank-only
  const isCard = hasSwitchers
    ? document.querySelector('input[name$="[paymentMethod]"]:checked')?.value === "card"
    : true;

  cardFields?.classList.toggle("hidden", !isCard);
  bankFields?.classList.toggle("hidden", isCard);

  // Only toggle "required" inside the two containers
  cardRequiredInputs.forEach((input) => input?.removeAttribute("required"));
  bankRequiredInputs.forEach((input) => input?.removeAttribute("required"));

  const activeInside = isCard ? cardRequiredInputs : bankRequiredInputs;
  activeInside.forEach((input) => input?.setAttribute("required", "required"));

  // inputsToCheck = required outside + required inside active container
  inputsToCheck = [...outsideRequiredInputs, ...activeInside].filter(Boolean);

  // console.log("inputsToCheck updated", inputsToCheck);

  if (!event || inputsToCheck.every(input => input.type === "checkbox" || !input.value)) {
    return // do not make button disabled on load and on change payment inputs if there is no values yet
  }

  validateDisabledButton(paymentSubmit, inputsToCheck);
}

export const paymentLogic = () => {

  paymentForm = document.querySelector(".payment-form");
  if (!paymentForm) {
    return
  }

  cvvInput = document.getElementById("card_cvv");
  cardInput = document.getElementById("card_number");
  cardExpiryDate = document.getElementById("card_expiry");
  paymentSubmit = document.getElementById("payment_submit");
  paymentDetails = document.getElementById("payment_details");
  paymentSwitchers = document.querySelectorAll('input[name$="[paymentMethod]"]');
  cardFields = document.getElementById('payment_card_details');
  bankFields = document.getElementById('payment_bank_details');
  // membershipCheckbox = document.getElementById("payment_membership");
  // termsCheckbox = document.getElementById("payment_terms");

  if (window.safari) {
    const paymentDiv = document.querySelector(".payment");
    if (paymentDiv) {
      paymentDiv.classList.add("payment--safari")
    }
  }

  if (cardInput) {
    cardInput.addEventListener("input", onChangeCard);
    cardInput.addEventListener("focus", onInputFocus);
  }
  if (cardExpiryDate) {
    cardExpiryDate.addEventListener("input", onChangeExpiry);
    cardExpiryDate.addEventListener("focus", onInputFocus);
  }
  if (cvvInput) {
    cvvInput.addEventListener("input", onChangeCVV);
    cvvInput.addEventListener("focus", onInputFocus);
  }
  if (paymentSubmit) {
    paymentSubmit.addEventListener("click", onPaymentSubmit);
  }
  const allRequired = Array.from(paymentForm.querySelectorAll("input[required]"));
  cardRequiredInputs = cardFields ? Array.from(cardFields.querySelectorAll("input[required]")) : [];
  bankRequiredInputs = bankFields ? Array.from(bankFields.querySelectorAll("input[required]")) : [];

  // required inputs NOT inside either container (always required)
  outsideRequiredInputs = allRequired.filter((input) => {
    if (!input) return false;
    const inCard = cardFields && cardFields.contains(input);
    const inBank = bankFields && bankFields.contains(input);
    return !inCard && !inBank;
  });

  allRequired.forEach((inputElement) => {
    if (inputElement) {
      inputElement.addEventListener("focus", onInputFocus);
      inputElement.addEventListener("input", onChangeInput);
      inputElement.addEventListener("blur", onBlurInput);
      if (inputElement.value) {
        inputElement.classList.add("ui-input--touched")
      }
    }
  });

  inputsToCheck = [...allRequired];
  // console.log("inputsToCheck load", inputsToCheck);

  if (paymentSwitchers && paymentSwitchers.length) {
    paymentSwitchers.forEach((radio) => {
      radio.addEventListener("change", updatePaymentUI);
    });
  }
  updatePaymentUI(null); // always run (card default if no switchers)
}
